import { Injectable } from "@angular/core";
import { merge } from "lodash-es";

import { UiInteraction } from "./ui-interaction.model";
import { generateTrackingKey } from "./ui-interaction.util";

@Injectable({
	providedIn: "root",
})
export class UiInteractionService {
	private trackingMap: Record<string, any> = {};

	getTrackingData(interaction: UiInteraction): any {
		const key = generateTrackingKey(interaction.context, interaction.event);
		return this.trackingMap[key];
	}

	registerTrackingData(...map: Record<string, any>[]) {
		this.trackingMap = merge(this.trackingMap, ...map);
	}
}
